import React, { useEffect, useRef } from "react";
import { cate } from "../../data/product";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Categories = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const items = gsap.utils.toArray(containerRef.current.children);

    items.forEach((item, index) => {
      gsap.from(item, {
        y: 50,
        opacity: 0,
        duration: 0.8,
        delay: index * 0.1, // stagger
        ease: "power3.out",
        scrollTrigger: {
          trigger: item,
          start: "top 90%",
          toggleActions: "play none none none", // play once
        },
      });
    });
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full mx-auto py-[4rem] px-4 h-full flex flex-wrap gap-[2rem] justify-center items-center"
    >
      {cate.map((category, index) => (
        <div
          key={index}
          className="relative flex justify-center items-center flex-wrap gap-[20px] p-8"
        >
          {/* Category Icon */}
          <img src={category.icon} alt={category.title} />

          {/* Category Text */}
          <div>
            <h1 className="text-[20px] font-bold">
              {category.secure}{" "}
              <span className="text-gradient">{category.title}</span>{" "}
              {category.price}
            </h1>
            <p className="text-[18px] font-light font-Outfit">
              {category.detail}
            </p>
          </div>

          {/* Gradient Right Border (all except last item) */}
          {index !== cate.length - 1 && (
            <span
              className="hidden lg:block absolute right-0 top-1/4 h-1/2 w-[2px]"
              style={{ background: "#000000" }}
            ></span>
          )}
        </div>
      ))}
    </div>
  );
};

export default Categories;
